/**
 * Nutrition Tracking Constants
 */

import type { MealType, NutritionLogStatus } from './types';

export const MEAL_TYPES: { value: MealType; label: string; icon: string }[] = [
  { value: 'breakfast', label: 'Breakfast', icon: '🌅' },
  { value: 'lunch', label: 'Lunch', icon: '☀️' },
  { value: 'dinner', label: 'Dinner', icon: '🌙' },
  { value: 'snack', label: 'Snack', icon: '🍎' },
  { value: 'water', label: 'Water', icon: '💧' },
];

export const MEAL_TYPE_LABELS: Record<MealType, string> = {
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  snack: 'Snack',
  water: 'Water',
};

export const STATUS_LABELS: Record<NutritionLogStatus, string> = {
  pending: 'Pending Review',
  approved: 'Approved',
  rejected: 'Rejected',
  needs_edit: 'Needs Changes',
};

export const STATUS_COLORS: Record<NutritionLogStatus, { bg: string; text: string }> = {
  pending: { bg: 'bg-warning/15', text: 'text-warning' },
  approved: { bg: 'bg-success/15', text: 'text-success' },
  rejected: { bg: 'bg-destructive/15', text: 'text-destructive' },
  needs_edit: { bg: 'bg-warning/15', text: 'text-warning' },
};

// Validation limits
export const NUTRITION_LIMITS = {
  calories: { min: 0, max: 10000 },
  protein_g: { min: 0, max: 500 },
  carbs_g: { min: 0, max: 1000 },
  fat_g: { min: 0, max: 500 },
  fiber_g: { min: 0, max: 100 },
  water_oz: { min: 0, max: 300 },
};

// Water increment options (in oz)
export const WATER_INCREMENTS = [8, 12, 16, 20, 24, 32];

// Default goals (for display when no goal is set)
export const DEFAULT_GOALS = {
  calories: 2000,
  protein_g: 150,
  carbs_g: 250,
  fat_g: 65,
  fiber_g: 30,
  water_oz: 64,
};

// Macro colors for charts
export const MACRO_COLORS = {
  protein: '#ef4444', // red
  carbs: '#3b82f6', // blue
  fat: '#eab308', // yellow
  fiber: '#22c55e', // green
};
